'use client';

import { 
  FC, 
  ReactNode, 
  SetStateAction, 
  createContext,
  Dispatch,
  useState,
  useLayoutEffect,
  useMemo
} from 'react';
import themeConfig from '@/config/theme.config';

export interface IThemeContextProps {
  fontSize: number;
  setFontSize: Dispatch<SetStateAction<number>>;
}

export const ThemeContext = createContext<IThemeContextProps>({} as IThemeContextProps);

interface IThemeContextProviderProps {
  children: ReactNode;
}

export const ThemeContextProvider: FC<IThemeContextProviderProps> = ({ children }) => {

  const [fontSize, setFontSize] = useState<number>(
    typeof window !== 'undefined' && Number(localStorage.getItem('ktc_fontSize'))
			? Number(localStorage.getItem('ktc_fontSize'))
			: themeConfig.fontSize,
  );
  useLayoutEffect(() => {
    localStorage.setItem('ktc_fontSize', fontSize?.toString());
  }, [fontSize]);

  const values: IThemeContextProps = useMemo(
    () => ({
      fontSize,
      setFontSize
    }),
    [fontSize],
  );

  return <ThemeContext.Provider value={values}>{children}</ThemeContext.Provider>
}